enum SortingOrder {
  ASC = 'ASC', DESC = 'DESC',
}

export default SortingOrder;
